// Natural ("human") ordering for names that carry numbers.
//
// A bare `a.localeCompare(b)` is lexical, so a farm's own block names come back
// as A1, A10, A11, … A19, A2, A20 — A2 lands two-thirds down a 54-row list and
// the operator scanning for it concludes it isn't there. The fix is one option,
// `{ numeric: true }`, and the reason this is a module rather than an inline
// option is that it is easy to get right once and easy to forget everywhere
// else: the same file can sort valves correctly and blocks wrongly.
//
// Use for anything an operator reads and scans: block names, valve labels,
// tank labels, pallet refs, row/bay numbers.

const COLLATOR = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })

/** Compare two names the way a person reads them. Nulls sort last. */
export function compareNatural(a: string | null | undefined, b: string | null | undefined): number {
  const x = a ?? '', y = b ?? ''
  if (!x && !y) return 0
  if (!x) return 1          // unnamed rows go to the bottom, never the top
  if (!y) return -1
  return COLLATOR.compare(x, y)
}

/** `array.sort(byNatural(r => r.block_name))` */
export function byNatural<T>(key: (row: T) => string | null | undefined) {
  return (a: T, b: T) => compareNatural(key(a), key(b))
}
